export default {
  id: "potentialClientTable",
  code: "CN",
  text: {
    'Contacts': '联系人',
		'New Contact': '新增联系人',
		'Name': '学员',
		'Age': '年龄',
		'Guardian Name': '家长姓名',
		'Contact Number': '联系电话',
		'Tags': '标签',
		'Tags Filter': '标签过滤',
		'Edit Contact': '编辑联系人',
		'Add Class': '加入班级',
		'Transfer to student': '转为学员',
		'Delete': '删除',
    'You are over the student limit, please upgrade to premium version': '您目前的学员上限为50个学员, 添加更多学员请升级为高级版',
		'Search contacts': '搜索联系人',
		'Proceed to delete contact: {client}?': '您确认要删除联系人 {client} 吗？',
		'Delete Contact': '删除联系人',
		'Proceed to transfer to student?': '确认转为学员？',
		'Proceed to delete tag?': '确认要删除标签吗？',
		'Contact Custom Fields': '联系人自定义字段'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/locale.js